'use strict';

module.exports = {
    nonAllocated: 'nonAllocated',
};
